module.exports = __webpack_public_path__ + "static/health-sickness-116ef100281707cffff19d325ceefc7d.jpg";